import {useCallback} from 'react'
import serviceRiddles from 'services/api/riddlesCRUD'
import {useAppDispatch} from 'store/index'
import {showModal} from 'store/modal/slice'
import {useAdminContext} from 'src/providers/AdminProvider/AdminProvider'
import {isEmptyValidate , isNotLatLettersValidate} from 'src/lib/validators'

export const useUpdateRiddle = () => {
  const dispatch = useAppDispatch()

  const {
    langForm,
    riddleForm,
    answerForm,
    slugForm,
    idRiddleForm,
    setMutateAction,
  } = useAdminContext()

  const showSuccessHint = () => {
    dispatch(showModal({
      type: 'Hint',
      props: {
        type: 'success',
        message: 'Загадка успешно обновлена!',
      },
    }))
  }

  const showErrorHint = (message: string | null) => {
    let hintMessage = ''
    if (message && message.indexOf('CONFLICT') !== -1) {
      hintMessage = 'Загадка с таким слагом на выбранном языке уже существует!'
    } else {
      hintMessage = 'Ошибка обновления загадки!'
    }
    dispatch(showModal({
      type: 'Hint',
      props: {
        type: 'error',
        message: hintMessage,
      },
    }))
  }

  const isValidUpdateRiddleForm = !isEmptyValidate(idRiddleForm)
    && (!isNotLatLettersValidate(slugForm) || isEmptyValidate(slugForm))
    && !(
      isEmptyValidate(answerForm)
      && (isEmptyValidate(langForm) || langForm === null)
      && isEmptyValidate(riddleForm)
      && isEmptyValidate(slugForm)
    )

  const updateRiddle = useCallback(async () => {
    if (isValidUpdateRiddleForm) {
      try {
        dispatch(showModal({
          type: 'Loader',
          props: {},
        }))
        await serviceRiddles.updateRiddle(idRiddleForm, {
          answer: isEmptyValidate(answerForm) ? undefined : answerForm,
          lang: isEmptyValidate(langForm) || langForm === null ? undefined : langForm,
          riddle: isEmptyValidate(riddleForm) ? undefined : riddleForm,
          slug: isEmptyValidate(slugForm) ? undefined : slugForm,
        })

        setMutateAction('update')
        showSuccessHint()
      } catch(error) {
        showErrorHint((error as Error).message)
      }
    }
  }, [isValidUpdateRiddleForm, riddleForm, answerForm, slugForm, langForm])

  return {
    isValidUpdateRiddleForm,
    updateRiddle,
  }
}
